export default [
  {
    label: "Administrador",
    module: "admin",
    permissions: ["admin_dash", "admin_alerts", "admin_reportes"],
    items: [
      {
        label: "Dashboard",
        icon: "fas fa-tv",
        link: "/admin/dashboard",
        permission: "admin_dash",
      },
      {
        label: "Alertas",
        icon: "fas fa-mail-bulk",
        link: "/admin/alertas",
        permission: "admin_alerts",
      },
      {
        label: "Reportes",
        icon: "fas fa-file-contract",
        link: "/admin/reportes",
        permission: "admin_reportes",
      },
    ],
  },
  {
    label: "Oficina",
    module: "office",
    permissions: ["office_caja", "office_actas", "office_cartas"],
    items: [
      {
        label: "Caja",
        icon: "fas fa-cash-register",
        link: "/office/caja",
        permission: "office_caja",
      },
      //   {
      //     label: "Caseta",
      //     icon: "fas fa-door-open",
      //     link: "/office/caseta",
      //     permission: "office_caja",
      //   },
      {
        label: "Actas Administrativas",
        icon: "fas fa-user-times",
        link: "/office/actas",
        permission: "office_actas",
      },
      {
        label: "Cartas compromiso",
        icon: "fas fa-signature",
        link: "/office/cartas",
        permission: "office_cartas",
      },
    ],
  },
  {
    label: "Unidades",
    module: "unit",
    permissions: [
      "unit_lista",
      "unit_asignacion",
      "unit_entrega",
      "unit_recibir",
      "unit_percances",
      "unit_historial",
    ],
    items: [
      {
        label: "Listado",
        icon: "fas fa-truck",
        link: "/unit/listado",
        permission: "unit_lista",
      },
      {
        label: "Asignacion",
        icon: "fas fa-clock",
        link: "/unit/asignacion",
        permission: "unit_asignacion",
      },
      {
        label: "Entrega a chofer",
        icon: "fas fa-user-check",
        link: "/unit/entrega",
        permission: "unit_entrega",
      },
      {
        label: "Recibir en taller",
        icon: "fas fa-user-check",
        link: "/unit/recepcion",
        permission: "unit_recibir",
      },
      {
        label: "Revision de percances",
        icon: "fas fa-video",
        link: "/unit/revision",
        permission: "unit_percances",
      },
      {
        label: "Historial",
        icon: "fas fa-history",
        link: "/unit/historial",
        permission: "unit_historial",
      },
    ],
  },
  {
    label: "Inventario",
    module: "warehouse",
    permissions: [
      "warehouse_moves",
      "warehouse_inventario",
      "warehouse_materials",
    ],
    items: [
      {
        label: "Movimientos",
        icon: "fas fa-exchange-alt",
        link: "/warehouse/movimientos",
        permission: "warehouse_moves",
      },
      {
        label: "Inventario",
        icon: "fas fa-boxes",
        link: "/warehouse/inventario",
        permission: "warehouse_inventario",
      },
      {
        label: "Materiales",
        icon: "fas fa-shapes",
        link: "/warehouse/materiales",
        permission: "warehouse_materials",
      },
    ],
  },
  {
    label: "Taller",
    module: "taller",
    permissions: ["taller_mant", "taller_programar", "taller_historial", "taller_campana"],
    items: [
      {
        label: "Programar",
        icon: "fas fa-calendar-alt",
        link: "/taller/programar",
        permission: "taller_programar",
      },
      {
        label: "Mantenimientos",
        icon: "fas fa-tools",
        link: "/taller/mantenimientos",
        permission: "taller_mant",
      },
      {
        label: "Campañas",
        icon: "fas fa-calendar",
        link: "/taller/campana",
        permission: "taller_campana",
      },
      {
        label: "Historial",
        icon: "fas fa-list",
        link: "/taller/historial",
        permission: "taller_historial",
      },
    ],
  },
  {
    label: "Trabajadores",
    module: "workers",
    permissions: ["worker_index", "worker_banned", "worker_credenciales"],
    items: [
      {
        label: "Trabajadores",
        icon: "fas fa-user",
        link: "/workers/index",
        permission: "worker_index",
      },
      {
        label: "Credenciales",
        icon: "fas fa-id-card",
        link: "/workers/idcards",
        permission: "worker_credenciales",
      },
      {
        label: "No recomendados",
        icon: "fas fa-ban",
        link: "/workers/blacklist",
        permission: "worker_banned",
      },
    ],
  },
  {
    label: "Catalogos",
    module: "catalogs",
    permissions: [
      "cats_tpmat",
      "cats_tpserv",
      "cats_tpunidad",
      "cats_empresas",
      "cats_plantas",
      "cats_proveedores",
      "cats_funcion",
      "cats_usuarios",
    ],
    items: [
      {
        label: "Tipo de materiales",
        icon: "fas fa-shapes",
        link: "/catalogs/tpmat",
        permission: "cats_tpmat",
      },
      {
        label: "Tipo de servicios",
        icon: "fas fa-layer-group",
        link: "/catalogs/tpserv",
        permission: "cats_tpserv",
      },
      {
        label: "Tipo de unidad",
        icon: "fas fa-truck",
        link: "/catalogs/tpunidad",
        permission: "cats_tpunidad",
      },
      {
        label: "Empresas",
        icon: "fas fa-building",
        link: "/catalogs/empresas",
        permission: "cats_empresas",
      },
      {
        label: "Plantas",
        icon: "fas fa-industry",
        link: "/catalogs/plantas",
        permission: "cats_plantas",
      },
      {
        label: "Proveedores",
        icon: "fas fa-building",
        link: "/catalogs/proveedores",
        permission: "cats_proveedores",
      },
      {
        label: "Funcionamiento",
        icon: "fas fa-tasks",
        link: "/catalogs/funcionamiento",
        permission: "cats_funcion",
      },
      {
        label: "Usuarios",
        icon: "fas fa-user-plus",
        link: "/catalogs/users",
        permission: "cats_usuarios",
      },
    ],
  },
];
